// extracted by mini-css-extract-plugin
module.exports = {"avatarRowLayout":"appearance_avatarRowLayout__1KTL3","avatarColumnLayout":"appearance_avatarColumnLayout__2biUi","churchLogo":"appearance_churchLogo__Se2e8"};